import { getLxCxSubDeviceTypesByDeviceType, SubDeviceTypeEnum } from "@/constants/deviceManage";
import { isAnXing } from "@/utils/device";
import { Modal } from "antd";
import { useMemo, useState } from "react";
import CameraDlmForm from "./cameraDlm";
import MotorZdwForm from "./motorZdw";
import CameraYzyForm from "./cameraYzy";
import RadarYzyForm from "./radarYzy";
import InsAqiForm from "./insAqi";
import LaserRadarBsdForm from "./laserRadarBsd";
import AxForwardCameraForm from "./axForwardCamera";
import AxForwardMmwRadarForm from "./axForwardMmwRadar";
import AxDmsCameraForm from "./axDmsCamera";
import AxBsdCameraForm from "./axBsdCamera";

interface iModelProp {
    data: any,
    closeModal: () => void; // 关闭弹窗的方法
}

const SetCalibrateModal = (props: iModelProp) => {

    const { closeModal, data } = props;
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefreshAll = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    const subDeviceList = useMemo(() => {
        const list = getLxCxSubDeviceTypesByDeviceType(data.deviceType);
        // 安行设备下发弹窗展示拉线电机，以及前视相机自动标定（ax_forward_camera = 9）
        if (isAnXing(data.deviceType)) {
            return list.filter((type) =>
                type === SubDeviceTypeEnum.wireMotor ||
                type === SubDeviceTypeEnum.ax_forward_camera
            );
        }
        return list;
    }, [data]);
    console.log('subDeviceList', subDeviceList);
    console.log('deviceType', data.deviceType);

    return (
        <Modal title="下发配置参数" onCancel={closeModal} width={'40%'} open footer={null}>
            {
                subDeviceList.includes(SubDeviceTypeEnum.forwardIntegratedMachine_duolaimu) && <CameraDlmForm id={SubDeviceTypeEnum.forwardIntegratedMachine_duolaimu} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun) && <CameraYzyForm id={SubDeviceTypeEnum.forwardIntegratedMachine_camera_yuanzhiyun} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun) && <RadarYzyForm id={SubDeviceTypeEnum.forwardIntegratedMachine_radar_yuanzhiyun} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.wireMotor) && <MotorZdwForm id={SubDeviceTypeEnum.wireMotor} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.ins_aqi) && <InsAqiForm id={SubDeviceTypeEnum.ins_aqi} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.bsd_laser_radar) && <LaserRadarBsdForm id={SubDeviceTypeEnum.bsd_laser_radar} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.ax_forward_camera) && <AxForwardCameraForm id={SubDeviceTypeEnum.ax_forward_camera} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.ax_forward_mmw_radar) && <AxForwardMmwRadarForm id={SubDeviceTypeEnum.ax_forward_mmw_radar} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.ax_dms_camera) && <AxDmsCameraForm id={SubDeviceTypeEnum.ax_dms_camera} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
            {
                subDeviceList.includes(SubDeviceTypeEnum.ax_bsd_camera) && <AxBsdCameraForm id={SubDeviceTypeEnum.ax_bsd_camera} sn={data.sn} refreshTrigger={refreshTrigger} onRefreshAll={handleRefreshAll} />
            }
        </Modal>
    );

}

export default SetCalibrateModal;